<template>
    <div id="tablePrint">
    <b-table
        show-empty
        responsive
        empty-text="ไม่มีรายละเอียดข้อมูลยอดขาย"
        empty-filtered-text="ไม่พบข้อมูลที่ต้องการค้นหา"
        :fields="columnName"
        :items="filterData"
        class="scroll-bar-pop text-center"
        foot-clone
    >
        <template slot="index" slot-scope="data">{{ data.index+1 }}</template>
        <template slot="sender" slot-scope="row">{{ row.item.sender.name}}</template>
        <template slot="status_transfer" slot-scope="row">
            <b-badge variant="status-parcel-success"
                class="report"
                v-if="row.item.status_transfer == 'TRANSFERRED'" >
                โอนเงินสำเร็จแล้ว
            </b-badge>
            <b-badge variant="status-parcel-warning" 
                class="report"
                v-else-if="row.item.status_transfer == 'PENDING_TRANSFER'">
                รอดำเนินการโอนเงิน
            </b-badge>
            <b-badge variant="dark"
                class="report"
                v-else>
                รอตรวจสอบ
            </b-badge>
        </template>
        <template slot="status" slot-scope="row">
            <b-badge :variant="statusInfo(row.item).color +' report'" >
                {{statusInfo(row.item).status}}
            </b-badge>
        </template>
        <template slot="manage" slot-scope="row" v-if="isMember()">
            <button 
                v-if="$THEME.name != 'shipsbuy'"
                class="btn btn-sm btn-info px-3" 
                @click="printReceiptShippop(row.item.receipt_id_url)" 
                :disabled="!row.item.receipt_id_url" 
            >ใบเสร็จ COD</button>
            <button 
                v-else
                class="btn btn-sm btn-info px-3" 
                @click="printReceiptCodPop(row.item.transfer_transaction_id)"
                :disabled="!row.item.transfer_transaction_id"
            >
                ใบเสร็จ COD
            </button>
        </template>
        <template slot="FOOT_index">{{'รวม'}}</template>
        <template slot="FOOT_commission">{{footerTotal.commission}}</template>
        <template slot="FOOT_receipt_no">{{&nbsp;}}</template>
        <template slot="FOOT_shop_name">{{&nbsp;}}</template>
        <template slot="FOOT_barcode">{{&nbsp;}}</template>
        <template slot="FOOT_date_time_shipping">{{&nbsp;}}</template>
        <template slot="FOOT_date_time_complete">{{&nbsp;}}</template>
        <template slot="FOOT_status">{{&nbsp;}}</template>
        <template slot="FOOT_to_name">{{&nbsp;}}</template>
        <template slot="FOOT_sender">{{&nbsp;}}</template>
        <template slot="FOOT_date_time_transfer">{{&nbsp;}}</template>
        <template slot="FOOT_cod_amount">{{&nbsp;}}</template>
        <template slot="FOOT_service_fee">{{&nbsp;}}</template>
        <template slot="FOOT_r_cod_amount">{{&nbsp;}}</template>
        <template slot="FOOT_status_transfer">{{&nbsp;}}</template>
        <template slot="FOOT_manage">{{&nbsp;}}</template>

    </b-table>
     <div class="mt-3">
        <b-pagination
            :total-rows="pagination.total_item"
            :per-page="pagination.per_page"
            @input="changePage"
            align="right"
        >
        </b-pagination>
    </div>
    </div>
</template>
<script>
import columnExcel from "./js/columnsCod.js"
import { statusInfo } from "@/plugins/statusCourier.js"
import { getReceiptCodPop } from "@/axios/cod.js";

export default {
    props: {
        listOrders: Array,
        pagination: Object
    },
    data(){
        return {
            userLogin:'',
            statusInfo: statusInfo,
        }
    },
    mounted() {
        this.userLogin = JSON.parse(localStorage.getItem("user"))
    },
    methods:{
        changePage(i){
            if (this.pagination.current_page == i) return
            this.pagination.current_page = i
            this.pagination.getOrder()
        },
        isWho(){
            return this.userLogin.role
        },
        isMember() {
            return !!this.$route.params.Id;
        },
        printReceiptCodPop(transactionId){
            getReceiptCodPop(transactionId).then( res => {
                window.open( res.url , '_blank');
            });
        },
        printReceiptShippop(linkReceipt){
            window.open(linkReceipt, '_blank')
        }
    },
    computed:{
        columnName(){
            let col = columnExcel
            if( this.isMember() ){
                col.push( { field:'manage', key: "manage", label: "จัดการ" } );
            }
            if( this.isWho() == 'admin' || this.isWho() == 'member'){
                return col.filter(function (col) {
                    return [ 'shop_name' ].indexOf(col.key) < 0
                })
            }
            return col
        },
        filterData(){
            return this.listOrders
        },
        footerTotal() {
            let total = { commission : 0 }
            this.filterData.forEach(item => {
                total.commission += +item.commission || 0
            })

            if( total.commission < 1 ){
                return total.commission = ''
            }
            total.commission = total.commission.toFixed(2)
            return total
        }
    }
}
</script>